/*
 * This code is the intellectual property of Bulb Inc. and other software publishers;
 * it may not be altered, copied or disclosed without prior written approval.
 * Copyright 2020, Bulb Inc.  For more information, please email contact@hellobulb.com.
 */
'use strict';

/**
 * A directive that ensures <dl> <dt> and <dd> elements are structured correctly.
 *
 * @example
  <tabset class="bulb-author-tabs" bulb-tabset>
  <accordion class="dashboard-settings-accordion" bulb-tabset>
 *
 */
angular.module('bulbApp.utilsModule')

.directive('bulbTabset', ['$interval', function ($interval) {
  return {
    restrict: 'A',
    terminal: true,
        transclude: false,
    link: function(scope, element) {

      /**
      * Checking every 100ms to see when the tabset or accordion has been rendered as a description list,
      * and then fixing it for accessibility.
      */

      var counter = 0;
      var watchForTabsetRender = $interval(function() {
        if (counter < 20) {
          counter++;
          var isAccordion = element.is('accordion');
          var tabset = element.find('dl dd');
          if (tabset.length > 0) {
            for(var i = 0; i < tabset.length; i++) {
              $(tabset[i]).before('<dt></dt>');
              if(isAccordion)  {
                $(tabset[i]).removeAttr('role');
              }
              var anchor = $(tabset[i]).find('a');
              if(anchor.length === 1 && typeof anchor.attr('href') === 'undefined') {
                // anchor has no href attribute
                anchor.attr('href','javascript:void(0)');// jshint ignore:line
              }
            }
            //IIFE for handling accessibility for TABSET
            if(!isAccordion){

            (function() {

              var tabs;
              var panels;

              var keys = {
                end: 'End',
                home: 'Home',
                left: 'ArrowLeft',
                right: 'ArrowRight',
                enter: 'Enter'
              };

              // Selecting all the tab and tab panels
              function generateListforTabsAndPanels() {
                tabs = element[0].querySelectorAll('dd[role="tab"]');
                panels = element[0].querySelectorAll('dd[role="tabpanel"]');
              }

              generateListforTabsAndPanels();

              //Adding click and keydown listener for tabs for given index
              function addListeners(index) {
                tabs[index].addEventListener('click', clickEventListener);
                tabs[index].addEventListener('keydown', keydownEventListener);

              }

              for (var tabIndex = 0; tabIndex < tabs.length; ++tabIndex) {
                addListeners(tabIndex);
              }

              //Function for handling click Event on Tab
              function clickEventListener(event) {
                var tab = event.target.closest('dd');
                activateTab(tab);
              }

              var currentTab = 0;
              //Function for handling Keydown Event on Tab
              //Even when element in present in DOM
              //Focus not going to Element until and unless we use timeout
              function keydownEventListener(event) {

                var key = event.key;
                if (key === keys.left) {
                  if (currentTab > 0) {
                    currentTab--;

                  } else {
                    currentTab = tabs.length - 1;
                  }
                  setTimeout(function () {
                    tabs[currentTab].focus();

                  }, 500);
                } else if (key === keys.right) {
                  if (currentTab < tabs.length - 1) {
                    currentTab++;
                  } else {
                    currentTab = 0;
                  }
                  setTimeout(function () {
                    tabs[currentTab].focus();

                  }, 500);

                } else if (key === keys.enter) {
                  var tab = event.target;
                  activateTab(tab);

                } else if (key === keys.home) {
                  currentTab = 0;
                  setTimeout(function () {
                    tabs[currentTab].focus();

                  }, 500);

                } else if (key === keys.end) {
                  event.preventDefault();
                  currentTab = tabs.length - 1;
                  setTimeout(function () {
                    tabs[currentTab].focus();

                  }, 500);
                }
              }

              activateTab(tabs[0]);

              // Activates any given tab panel
              function activateTab(tab) {
                if (tab === undefined) {
                  return;
                }
                // Deactivate all other tabs
                deactivateTabs();
                // Set the tab as selected
                tab.setAttribute('aria-selected', 'true');
                tab.setAttribute('tabindex', '0');
                var controls = tab.getAttribute('aria-controls');
                // Remove hidden attribute from tab panel to make it visible
                var tabPanel = document.getElementById(controls);
                if (tabPanel) {
                  tabPanel.removeAttribute('hidden');
                }
              }

              //Deactivate all the TABs and hide all the Tab Panels
              function deactivateTabs() {
                for (var tIndex = 0; tIndex < tabs.length; tIndex++) {
                  tabs[tIndex].children[0].setAttribute('tabindex', '-1');
                  tabs[tIndex].setAttribute('tabindex', '-1');
                  tabs[tIndex].setAttribute('aria-selected', 'false');
                }
                for (var panelIndex = 0; panelIndex < panels.length; panelIndex++) {
                  panels[panelIndex].setAttribute('hidden', 'hidden');
                }
              }

              //Function for removing click and keydown listener for given tab index
              function removeListeners(indexForTabs) {
                tabs[indexForTabs].removeEventListener('click', clickEventListener);
                tabs[indexForTabs].removeEventListener('keydown', keydownEventListener);

              }

              //Remove all the Listener associated with Tabs
              scope.$on('$destroy', function() {
                for (var indexForTabs = 0; indexForTabs < tabs.length; ++indexForTabs) {
                  removeListeners(indexForTabs);
                }
              });
            })();
            }

            $interval.cancel(watchForTabsetRender);
          }
        } else {
          $interval.cancel(watchForTabsetRender);
          }
      }, 100);


    }
  };
}]);
